import React from 'react';
import classNames from 'classnames';
import cls from './TableHeaderRegistry.module.css';
import { useTableHeaderRegistry } from './useTableHeaderRegistry';

interface TableHeaderRegistryProps {
    classes?: string;
}

export const TableHeaderRegistry = ({ classes }: TableHeaderRegistryProps) => {
    const {} = useTableHeaderRegistry();
    return (
        <div className={classNames(cls.TableHeaderRegistry, [classes])}>
            <div className={classNames(cls.TableColumn, cls.TableData)}>
                {i18next.t('TableHeaderRegistry.result.tableData')}
            </div>
            <div className={classNames(cls.TableColumn, cls.TableEstimate)}>
                {i18next.t('TableHeaderRegistry.result.tableEstimate')}
            </div>
            <div className={classNames(cls.TableColumn, cls.TableSum)}>
                {i18next.t('TableHeaderRegistry.result.tableSum')}
            </div>
            <div className={classNames(cls.TableColumn, cls.TableCurrency)}>
                {i18next.t('TableHeaderRegistry.result.tableCurrency')}
            </div>
            <div className={classNames(cls.TableColumn, cls.TableComment)}>
                {i18next.t('TableHeaderRegistry.result.tableComment')}
            </div>
        </div>
    );
};
